import {SignUp} from '@templates';

export default SignUp.ResendConfirm;
